import axios from 'axios'

class ConfigurationsService {
  getConfigurations = (page, size, sortType, sortOrder, platform, searchKey, isActive) =>
    axios({
      url: 'configurations',
      method: 'GET',
      params: {
        page,
        limit: size,
        asc: sortType && sortOrder === 'ascend' ? sortType : null,
        desc: sortType && sortOrder === 'descend' ? sortType : null,
        platform: platform || null,
        key: searchKey || null,
        isActive: isActive !== undefined ? isActive : null,
      },
    })

  getConfigurationById = (id) =>
    axios({
      url: `configurations/${id}`,
      method: 'GET',
    })

  createConfiguration = (data) =>
    axios({
      url: 'configurations',
      method: 'POST',
      data,
    })

  updateConfiguration = (id, data) =>
    axios({
      url: `configurations/${id}`,
      method: 'PUT',
      data,
    })

  deleteConfiguration = (id) =>
    axios({
      url: `configurations/${id}`,
      method: 'DELETE',
    })

  toggleConfigurationStatus = (id) =>
    axios({
      url: `configurations/${id}/toggle-status`,
      method: 'PUT',
    })
}

export default new ConfigurationsService()
